export const STAGING_AUTH_WALL_TOKEN_KEY = "inventumStagingAccessToken";

export function isStagingAuthWallHost(hostname) {
  return hostname === "staging.inventum3d.com";
}

export function isExpiredTokenPayload(payload, nowSeconds = Date.now() / 1000) {
  return !payload || !payload.exp || nowSeconds > payload.exp;
}

export function isSuperuserTokenPayload(payload) {
  return !!payload && payload.siteAdmin === true && Number(payload.siteStaffLevel) === 1;
}

export function canPassStagingAuthWall(payload, nowSeconds = Date.now() / 1000) {
  return isSuperuserTokenPayload(payload) && !isExpiredTokenPayload(payload, nowSeconds);
}
